<template>
    <div class="payment-container">
        <div class="form-item">
            <div class="form-content">
                <div class="label">{{ priceInfo.total.name }}</div>
                <div class="content">
                    <input readonly :value="`${priceInfo.total.val / 100}元`" />
                </div>
            </div>
        </div>
        <div class="flex">
            <div class="form-item">
                <div class="form-content">
                    <div class="label">{{ priceInfo.pay.name }}</div>
                    <div class="content">
                        <input readonly :value="`${priceInfo.pay.val / 100}元`" />
                    </div>
                </div>
            </div>
            <div class="form-item" v-if="priceInfo.deposit.val !== 0">
                <div class="form-content">
                    <div class="label">{{ priceInfo.deposit.name }}</div>
                    <div class="content">
                        <input readonly :value="`${priceInfo.deposit.val / 100}元`" />
                    </div>
                </div>
            </div>
        </div>

        <div class="form-item" v-show="providerList.length !== 1">
            <div class="form-content">
                <div class="label">支付方式</div>
                <div class="content">
                    <van-radio-group
                        v-model="formData.payType"
                        @change="onPayTypeChange"
                        direction="horizontal"
                        icon-size="14px"
                    >
                        <van-radio
                            v-for="item in providerList"
                            :key="item.val"
                            checked-color="#07c160"
                            :name="item.val"
                        >
                            {{ item.name }}
                        </van-radio>
                    </van-radio-group>
                </div>
            </div>
        </div>

        <div class="form-item" v-if="instalmentTerms.length !== 0">
            <div class="form-content">
                <div class="label">缴费方案</div>
                <div class="content">
                    <div class="instalment-type">
                        <div
                            class="item"
                            v-for="typeNum in instalmentTerms"
                            :key="`instalmentType${typeNum}`"
                            @click="formData.instalmentType = typeNum"
                            :class="formData.instalmentType === typeNum ? 'active-item' : ''"
                        >
                            <span class="t">{{ typeNum }}期</span>
<!--                            <span class="d">免息</span>-->
                            <div>月费率:0.00%</div>
                            <van-icon name="success" v-if="formData.instalmentType === typeNum" />
                        </div>
                    </div>
                    <div class="desc">*每月付款金额以账单为准</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getProviderTerms } from '@/utils/api.js'
import { RadioGroup, Radio } from 'vant'
const stages = ['xqf_axf', 'zhimago', 'antpay']

export default {
    props: ['productInfo', 'providerList', 'paidInfo', 'installmentInfo'],
    components: { VanRadioGroup: RadioGroup, VanRadio: Radio },
    computed: {
        stageFlag: function () {
            const payType = this.formData.payType || (this.providerList && this.providerList.length&& this.providerList[0]['val'])
            return stages.includes(payType)
        },
        priceInfo: function () {
            const _data = {
                total: { name: '总金额', val: 0 },
                deposit: { name: '预付款', val: 0 },
                pay: { name: '支付金额', val: 0 },
            }
            if (this.paidInfo) {
                _data.total.val = this.paidInfo.totalFee
                _data.pay.val = this.paidInfo.toPayFee
            }

            if (this.installmentInfo) {
                _data.total.val = this.paidInfo.totalFee
                _data.pay.name = this.stageFlag ? '先学后付' : '分期支付'
                _data.pay.val = this.installmentInfo.budgetFee
                _data.deposit.val = this.installmentInfo.depositFee || 0
            }
            return _data
        },
    },
    watch: {
        providerList: function () {
            if (this.providerList.length !== 0) {
                this.formData.payType = this.providerList[0]['val']
            }
        },
    },
    created() {
        if (this.providerList.length !== 0) {
            this.formData.payType = this.providerList[0]['val']
        }

        const providers = this.providerList.map(s => s.val)
        getProviderTerms({
          productNo: this.productInfo.packageNo,
          productType: 1,
          tradeProviders: providers,
          toPayFee: this.priceInfo.pay.val,
        }).then(res => {
          const termMap = {}
          res.data.forEach(item => {
            termMap[item.tradeProvider] = item.terms
          })
          this.providerTermMap = termMap

          this.onPayTypeChange()

        }).catch(() => {
          const termMap = {}
          this.providerList.forEach(s => {
            if ('antpay' === s.val) {
              if (this.priceInfo.pay.val >= 6980 * 100) {
                termMap[s.val] = [3, 6, 9, 12]
              } else if (this.priceInfo.pay.val >= 2980 * 100) {
                termMap[s.val] = [3, 6, 9]
              } else {
                termMap[s.val] = [3, 6]
              }
            } else if ('linglinggou' === s.val) {
              if (this.priceInfo.pay.val >= 2980 * 100) {
                termMap[s.val] = [3, 6, 12]
              } else {
                termMap[s.val] = [3, 6]
              }
            }
          })
          this.providerTermMap = termMap
          this.onPayTypeChange()
        })
    },
    data() {
        return {
            instalmentTerms: [],
            providerTermMap: {},

            formData: {
                payType: '',
                instalmentType: undefined,
            },
        }
    },
    methods: {
        onPayTypeChange() {
          // 预付款未支付
          if (this.installmentInfo) {
            if (this.installmentInfo.depositFee && this.installmentInfo.status === 'APPROVED') {
              this.instalmentTerms = []
              return
            }
          }

          this.instalmentTerms = this.providerTermMap[this.formData.payType] || []
          this.formData.instalmentType = (this.instalmentTerms && this.instalmentTerms.length) ? this.instalmentTerms[0] : undefined
        },

        getParams() {
            return { ...this.formData }
        },
    },
}
</script>

<style lang="scss" scoped>
.payment-container {
    max-width: 540px;
    margin: 28px auto 0;
    .flex {
        display: flex;
        > div {
            flex-grow: 1;
        }
    }
    .form-item {
        padding: 0 16px;
        font-size: 14px;
        min-height: 44px;
        border-bottom: 1px solid #eee;
        .form-content {
            display: flex;
        }
        .label {
            text-align-last: justify;
            padding: 0 10px;
            color: #999;
            width: 60px;
            flex-shrink: 0;
            line-height: 44px;
            margin-right: 6px;
        }
        .content {
            flex-grow: 1;
            min-height: 44px;
            position: relative;
        }
        input {
            width: 100%;
            height: 44px;
            border: none;
        }
        .van-radio-group {
            height: 44px;
            margin-left: 5px;
            color: #666;
        }
        .instalment-type {
            display: flex;
            flex-wrap: wrap;
            .item {
                position: relative;
                width: 90px;
                text-align: center;
                border: 1px solid #aaa;
                border-radius: 4px;
                padding: 8px;
                margin: 8px 8px 0 0;
                font-size: 12px;
                color: #bf0000;
                cursor: pointer;
                div {
                    margin-top: 6px;
                }
            }
            .active-item {
                border: 1px solid #f00;
                color: #f00;
            }
            .t {
                font-size: 14px;
                color: #333;
            }
            .d {
                padding-left: 12px;
            }
            .van-icon-success {
                position: absolute;
                top: 10px;
                right: 6px;
            }
        }
        .desc {
            color: #ff9933;
            font-size: 12px;
            margin: 12px 0 8px;
        }
    }
}
</style>
